import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	LogoutCooldownLimitDelete,
	LogoutCooldownLimitState,
	LogoutCooldownLimitUpdate,
} from "./logout-cooldown-limit.model";

const ACTION_PREFIX = "[Logout Cooldown Limit]";

export const LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	delete: `${ACTION_PREFIX} Delete`,
	deleteSuccess: `${ACTION_PREFIX} Delete Success`,
	deleteFail: `${ACTION_PREFIX} Delete Fail`,

	reset: `${ACTION_PREFIX} Clear`,
};

@Injectable({
	providedIn: "root",
})
export class LogoutCooldownLimitAction {
	get(): Action {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: LogoutCooldownLimitState): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.getFail,
			payload,
		};
	}

	update(payload: LogoutCooldownLimitUpdate): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	updateSuccess(): Action {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.updateSuccess,
		};
	}

	updateFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.updateFail,
			payload,
		};
	}

	delete(payload: LogoutCooldownLimitDelete): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.delete,
			payload,
		};
	}

	deleteSuccess(): Action {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.deleteSuccess,
		};
	}

	deleteFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.deleteFail,
			payload,
		};
	}

	reset() {
		return {
			type: LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.reset,
		};
	}
}
